import React from 'react';
import Skeleton from '../../common/Skeleton';
import '../../../pages/social/SocialStyling.css';

const SocialFeedSkeleton = () => {
    return (
        <div className="social-root" style={{ backgroundColor: '#F9FAFB', minHeight: '100vh' }}>
            <div className="social-feed-grid">
                <div className="social-feed-body">
                    {/* Left Sidebar Skeleton */}
                    <aside className="social-sidebar social-sidebar-left">
                        <div className="sidebar-sticky-wrapper">
                            <div
                                className="social-sidebar-desktop"
                                style={{ background: '#FFFFFF', padding: '16px', borderRadius: '12px', height: '400px' }}
                            >
                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '16px' }}>
                                    <Skeleton width="100px" height="100px" borderRadius="50%" />
                                    <Skeleton width="60%" height="24px" />
                                    <Skeleton width="40%" height="16px" />

                                    <div style={{ display: 'flex', justifyContent: 'space-around', width: '100%', marginTop: '16px' }}>
                                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '8px' }}>
                                            <Skeleton width="30px" height="20px" />
                                            <Skeleton width="40px" height="14px" />
                                        </div>
                                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '8px' }}>
                                            <Skeleton width="30px" height="20px" />
                                            <Skeleton width="40px" height="14px" />
                                        </div>
                                    </div>

                                    <Skeleton width="100%" height="48px" borderRadius="12px" style={{ marginTop: '24px' }} />
                                    <Skeleton width="100%" height="48px" borderRadius="12px" />
                                </div>
                            </div>
                        </div>
                    </aside>

                    {/* Main Content Skeleton */}
                    <main className="social-main-area">
                        {/* Stories Skeleton */}
                        <div className="social-feed-stories" style={{ height: '120px', display: 'flex', alignItems: 'center', gap: '16px', overflow: 'hidden' }}>
                            {[1, 2, 3, 4, 5, 6].map((i) => (
                                <div key={i} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '8px', minWidth: '70px' }}>
                                    <Skeleton width="64px" height="64px" borderRadius="50%" />
                                    <Skeleton width="50px" height="10px" />
                                </div>
                            ))}
                        </div>

                        {/* Create Post Skeleton */}
                        <div style={{
                            background: 'white',
                            borderRadius: '12px',
                            padding: '16px',
                            marginBottom: '20px',
                            boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
                        }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '16px' }}>
                                <Skeleton width="48px" height="48px" borderRadius="50%" />
                                <Skeleton width="100%" height="48px" borderRadius="24px" />
                            </div>
                            <div style={{ display: 'flex', gap: '12px', paddingTop: '12px', borderTop: '1px solid #f3f4f6' }}>
                                <Skeleton width="80px" height="32px" borderRadius="8px" />
                                <Skeleton width="80px" height="32px" borderRadius="8px" />
                            </div>
                        </div>

                        {/* Posts Skeleton */}
                        {[1, 2, 3].map((i) => (
                            <div key={`post-${i}`} style={{
                                background: 'white',
                                borderRadius: '12px',
                                padding: '20px',
                                marginBottom: '20px',
                                boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
                            }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '16px' }}>
                                    <Skeleton width="48px" height="48px" borderRadius="50%" />
                                    <div style={{ flex: 1 }}>
                                        <Skeleton width="120px" height="16px" style={{ marginBottom: '6px' }} />
                                        <Skeleton width="80px" height="12px" />
                                    </div>
                                </div>
                                <Skeleton width="100%" height="20px" style={{ marginBottom: '8px' }} />
                                <Skeleton width="80%" height="20px" style={{ marginBottom: '16px' }} />
                                <Skeleton width="100%" height="250px" borderRadius="8px" />
                            </div>
                        ))}
                    </main>

                    {/* Right Sidebar Skeleton */}
                    <aside className="social-sidebar social-sidebar-right">
                        <div className="sidebar-sticky-wrapper">
                            <div style={{ background: '#FFFFFF', padding: '16px', borderRadius: '12px' }}>
                                <Skeleton width="150px" height="20px" style={{ marginBottom: '20px' }} />
                                {[1, 2, 3, 4].map((i) => (
                                    <div key={i} style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '16px' }}>
                                        <Skeleton width="40px" height="40px" borderRadius="50%" />
                                        <div style={{ flex: 1 }}>
                                            <Skeleton width="100px" height="14px" style={{ marginBottom: '4px' }} />
                                            <Skeleton width="60px" height="12px" />
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </aside>
                </div>
            </div>
        </div>
    );
};

export default SocialFeedSkeleton;
